import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { updateProfileSchema, type MeResponse, type UpdateProfileInput } from '@koyomi/shared';
import { Button, Card, Input, MaskedInput, PageHeader, Select, useTheme, useToast } from '@koyomi/ui';
import { api } from '../../lib/api.ts';
import { useAuthStore } from '../../app/auth-store.ts';
import { setLocale } from '../../app/i18n.ts';

export function ProfilePage() {
  const { t } = useTranslation(['nav', 'common', 'auth']);
  const user = useAuthStore((s) => s.user)!;
  const toast = useToast();
  const { theme, setTheme } = useTheme();
  const form = useForm<UpdateProfileInput>({ resolver: zodResolver(updateProfileSchema), defaultValues: { name: user.name, phone: user.phone ?? '', locale: user.locale } });
  const onSubmit = form.handleSubmit(async (values) => {
    const res = await api<MeResponse>('/auth/me', { method: 'PATCH', body: { ...values, phone: values.phone || null, theme }, global: true });
    useAuthStore.setState({ user: res.user, businesses: res.businesses });
    if (values.locale) setLocale(values.locale);
    toast.push(t('common:status.saved'), 'success');
  });
  return (
    <>
      <PageHeader title={t('nav:profile')} subtitle={user.email} />
      <div className="k-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', maxWidth: 900 }}>
        <Card>
          <form className="k-stack" onSubmit={onSubmit} noValidate>
            <Input label={t('auth:invite.name')} {...form.register('name')} />
            <MaskedInput mask="phone" label={t('auth:invite.phone')} {...form.register('phone')} />
            <Select label={t('auth:profile.language')} {...form.register('locale')}>
              <option value="pt-BR">Português (Brasil)</option>
              <option value="en-US">English (US)</option>
            </Select>
            <Select label={t('auth:profile.theme')} value={theme} onChange={(e) => setTheme(e.target.value as 'light' | 'dark' | 'system')}>
              <option value="system">{t('common:theme.system')}</option>
              <option value="light">{t('common:theme.light')}</option>
              <option value="dark">{t('common:theme.dark')}</option>
            </Select>
            <div className="k-row" style={{ justifyContent: 'flex-end' }}>
              <Button type="submit" variant="primary" loading={form.formState.isSubmitting}>{t('common:actions.save')}</Button>
            </div>
          </form>
        </Card>
      </div>
    </>
  );
}
